import { Button, Grid } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Trans } from 'react-i18next';

export default function ASMBreadcrumb(props) {
  const links = props.links || [];

  const renderBreadCrumbs = link => {
    const items = link.map((value, index) => {
      const last = index === link.length - 1;
      return last ? (
        <Link
          underline='none'
          // textTransform='capitalize'
          color="text.primary">
          <Trans>{value.label}</Trans>
        </Link>
      ) : (
        <Link
          underline='none'
          color="inherit"
          // textTransform='capitalize'
          href={value.link} key={value.label}>
          <Trans>{value.label}</Trans>
        </Link>
      );
    });
    return [items];
  };
  const renderBreadCrumbsStatic = link => {
    const items = link.map((value, index) => {
      const last = index === link.length - 1;
      return last ? (
        <Link
          underline='none'
          // textTransform='capitalize'
          // color="text.primary"
          style={{ color: 'white' }}
        >
          <Trans>{value.label}</Trans>
        </Link>
      ) : (
        <Link
          underline='none'
          // color="inherit"
          style={{ color: 'white' }}
          // textTransform='capitalize'
          href={value.link} key={value.label}>
          <Trans>{value.label}</Trans>
        </Link>
      );
    });
    return [items];
  };
  return (
    <Grid container direction="row" style={{ minHeight: 34 }}>
      <Grid item xs={10} style={{ display: 'flex', alignItems: 'center' }}>
        <Breadcrumbs separator=">" aria-label="breadcrumb" style={{ color: props.isStatic ? 'white' : '' }}>
          {props.isStatic ? renderBreadCrumbsStatic(links) : renderBreadCrumbs(links)}
        </Breadcrumbs>
      </Grid>
      <Grid item xs={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {links.length === 1 ? <></> :
          <Button variant="contained"
            color="secondary"
            href={links.length > 0 && links.length > 1 ? links[links.length - 2].link : links[links.length - 1].link}
            style={{ minWidth: 34, maxWidth: 34, minHeight: 34, maxHeight: 34, borderRadius: '50%' }}
          >
            <ArrowBackIcon style={{ fontSize: 28 }} />
          </Button>
        }
      </Grid>
    </Grid>
  );
}
